import queryString from 'query-string';
import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

export const fetchCustomerOrders = (pageable: PageableQueryParams = {}): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId() === 'current' ? '' : '/' + getCustomerId();
    const endpoint = `/api/customerOrders${customerId}${query}`;

    return callApi(endpoint);
};

export const fetchCustomerAbos = (customerId: string = getCustomerId()): Promise<CallApiResult> => {
    return callApi(`/api/customer/${customerId}/subscriptions`);
};

export const deleteCustomerAbo = (id: string, customerId: string = getCustomerId()): Promise<CallApiResult> => {
    return callApi(`/api/customer/${customerId}/subscriptions/${id}`, { method: 'DELETE' });
};
